import { createAction, props } from '@ngrx/store';

import { GridDefault, GridElement, GridNonDefault, GridStudio } from '../models/grid.models';

import { GridTypes } from '@app/shared/ui/models/grid-type.model';
import { Category } from '@core/domain/models/category.models';
import { ProductsArrayPublicModels } from '@features/productsArray';

export const CategoryActionTypes = {
    INIT_CATEGORY_GRID: '[category-grid] INIT_CATEGORY_GRID',
    CHANGE_CATEGORY: '[category-grid] CHANGE_CATEGORY',
    SET_GRIDTYPE: '[category-grid] SET_GRIDTYPE',
    SET_GRIDTYPE_SUCCESS: '[category-grid] SET_GRIDTYPE_SUCCESS',
    SET_TOTAL_CUANTITY_PRODUCTS: '[category-grid] SET_TOTAL_CUANTITY_PRODUCTS',
    LOAD_FIRST_PAGE_GRID_STUDIO: '[category-grid] LOAD_FIRST_PAGE_GRID_STUDIO',
    LOAD_FIRST_PAGE_GRID_NEW_COLLECTION: '[category-grid] LOAD_FIRST_PAGE_GRID_NEW_COLLECTION',
    LOAD_NEW_COLLECTION_CATEGORY_PRODUCTS: '[category-grid] LOAD_NEW_COLLECTION_CATEGORY_PRODUCTS',
    LOAD_NEW_COLLECTION_CATEGORY_PRODUCTS_SUCCESS: '[category-grid] LOAD_NEW_COLLECTION_CATEGORY_PRODUCTS_SUCCESS',
    LOAD_FIRST_PAGE_GRID_DEFAULT: '[category-grid] LOAD_FIRST_PAGE_GRID_DEFAULT',
    LOAD_NEXT_PAGE_GRID: '[category-grid] LOAD_NEXT_PAGE_GRID',
    LOAD_NEXT_PAGE_GRID_SUCCESS: '[category-grid] LOAD_NEXT_PAGE_GRID_SUCCESS',
    LOAD_LAST_PAGE_GRID_SUCCESS: '[category-grid] LOAD_LAST_PAGE_GRID_SUCCESS',
    LOAD_NEXT_PAGE_STUDIO: '[category-grid] LOAD_NEXT_PAGE_STUDIO',
    LOAD_NEXT_PAGE_STUDIO_SUCCESS: '[category-grid] LOAD_NEXT_PAGE_STUDIO_SUCCESS',
    LOAD_LAST_PAGE_STUDIO_SUCCESS: '[category-grid] LOAD_LAST_PAGE_STUDIO_SUCCESS',
    LOAD_NEXT_PAGE_GRID_NEW_COLLECTION: '[category-grid] LOAD_NEXT_PAGE_GRID_NEW_COLLECTION',
    LOAD_NEXT_PAGE_GRID_NEW_COLLECTION_SUCCESS: '[category-grid] LOAD_NEXT_PAGE_GRID_NEW_COLLECTION_SUCCESS',
    LOAD_NEXT_PAGE_STUDIO_NEW_COLLECTION: '[category-grid] LOAD_NEXT_PAGE_STUDIO_NEW_COLLECTION',
    LOAD_NEXT_PAGE_STUDIO_NEW_COLLECTION_SUCCESS: '[category-grid] LOAD_NEXT_PAGE_STUDIO_NEW_COLLECTION_SUCCESS',
    SCROLL_TO_POSITION_ID: '[category-grid] SCROLL_TO_POSITION_ID',
};

export const InitCategoryGrid = createAction(CategoryActionTypes.INIT_CATEGORY_GRID);

export const ChangeCategory = createAction(
    CategoryActionTypes.CHANGE_CATEGORY,
    props<{ category: Category }>()
);

export const ScrollToPositionId = createAction(
    CategoryActionTypes.SCROLL_TO_POSITION_ID,
    props<{ id: string }>()
);

export const SetGridTypeCategoryGrid = createAction(
    CategoryActionTypes.SET_GRIDTYPE,
    props<{ gridType: GridTypes; initGridType?: boolean }>()
);

export const SetGridTypeCategoryGridSuccess = createAction(
    CategoryActionTypes.SET_GRIDTYPE_SUCCESS,
    props<{ gridType: GridTypes; initGridType: boolean }>()
);

export const SetTotalQuantityProducts = createAction(
    CategoryActionTypes.SET_TOTAL_CUANTITY_PRODUCTS,
    props<{ totalQuantityProducts: number }>()
);

export const LoadNextPageGrid = createAction(CategoryActionTypes.LOAD_NEXT_PAGE_GRID);

export const LoadNextPageGridSuccess = createAction(
    CategoryActionTypes.LOAD_NEXT_PAGE_GRID_SUCCESS,
    props<{ ids: number[]; page: number }>()
);

export const LoadLastPageGridSuccess = createAction(CategoryActionTypes.LOAD_LAST_PAGE_GRID_SUCCESS);

export const LoadNextPageStudio = createAction(CategoryActionTypes.LOAD_NEXT_PAGE_STUDIO);

export const LoadNextPageStudioSuccess = createAction(
    CategoryActionTypes.LOAD_NEXT_PAGE_STUDIO_SUCCESS,
    props<{ ids: GridElement[]; page: number }>()
);

export const LoadLastPageStudioSuccess = createAction(CategoryActionTypes.LOAD_LAST_PAGE_STUDIO_SUCCESS);

export const LoadNextPageGridNewCollection = createAction(CategoryActionTypes.LOAD_NEXT_PAGE_GRID_NEW_COLLECTION);

export const LoadNextPageGridNewCollectionSuccess = createAction(
    CategoryActionTypes.LOAD_NEXT_PAGE_GRID_NEW_COLLECTION_SUCCESS,
    props<{ ids: number[]; page: number }>()
);

export const LoadNextPageStudioNewCollection = createAction(CategoryActionTypes.LOAD_NEXT_PAGE_STUDIO_NEW_COLLECTION);

export const LoadNextPageStudioNewCollectionSuccess = createAction(
    CategoryActionTypes.LOAD_NEXT_PAGE_STUDIO_NEW_COLLECTION_SUCCESS,
    props<{ ids: GridElement[]; page: number }>()
);

export const LoadFirstPageGrid = createAction(
    CategoryActionTypes.LOAD_FIRST_PAGE_GRID_DEFAULT,
    props<{ grid: GridDefault }>()
);

export const LoadFirstPageStudio = createAction(
    CategoryActionTypes.LOAD_FIRST_PAGE_GRID_STUDIO,
    props<{ grid: GridStudio }>()
);

export const LoadFirstPageNewCollection = createAction(
    CategoryActionTypes.LOAD_FIRST_PAGE_GRID_NEW_COLLECTION,
    props<{ grid: GridNonDefault }>()
);

export const LoadNewCollectionCategoryProducts = createAction(
    CategoryActionTypes.LOAD_NEW_COLLECTION_CATEGORY_PRODUCTS,
    props<{ categories: string[]; title: string }>()
);

export const LoadNewCollectionCategoryProductsSuccess = createAction(
    CategoryActionTypes.LOAD_NEW_COLLECTION_CATEGORY_PRODUCTS_SUCCESS,
    props<{
        data: Array<{
            categoryGrids: ProductsArrayPublicModels.PublicCategoryPlatformStudio;
            categoryId: string;
        }>;
    }>()
);
